<template>
	<b-sidebar
		id="add-awards"
		v-model="visibleChanges"
		footer-class="bg-transparent"
		bg-variant="white"
		shadow
		backdrop
		lazy
		header-class="py-1 pr-0  bg-transparent"
		@hidden="closeSidebar()"
		body-class="p-1"
		width="95%"
		:title="title"
	>
		<h4 v-if="counterSons == 0" class="text-center p-1 font-weight-bolder">SIN HIJOS</h4>
		<div v-else>
			<b-tabs v-model="indexLivingTab">
				<b-tab>
					<template slot="title">
						Vivos
						<b-badge variant="danger" class="ml-1">{{ livingCounter }}</b-badge>
					</template>
				</b-tab>
				<b-tab>
					<template slot="title">
						Muertos
						<b-badge variant="danger" class="ml-1">{{ deadCounter }}</b-badge>
					</template>
				</b-tab>
			</b-tabs>
			<b-tabs v-model="indexTab">
				<b-tab v-for="(tab, index) in yearsTab" :key="`${index}-year`">
					<template slot="title">
						{{ tab.year }}
						<b-badge variant="danger" class="ml-1">{{ tab.counter }}</b-badge>
					</template>
					<div class="border rounded p-1" style="min-height: calc(100vh - 150px)">
						<b-row>
							<!-- CP -->
							<b-col md="4" xl="3">
								<ShowChicksGlobalByEvo
									type_evo="CP"
									:sons="posturasCP"
									:areDeads="indexLivingTab === 1"
								/>
							</b-col>
							<!-- CA -->
							<b-col md="4" xl="4">
								<ShowChicksGlobalByEvo
									type_evo="CA"
									:sons="posturasCA"
									:areDeads="indexLivingTab === 1"
								/>
							</b-col>
							<!-- SPEC -->
							<b-col md="4" xl="5">
								<ShowChicksGlobalByEvo
									type_evo="SPEC"
									:sons="posturasSpec"
									:areDeads="indexLivingTab === 1"
								/>
							</b-col>
						</b-row>
					</div>
				</b-tab>
				<div v-if="yearsTab.length === 0" class="text-center font-weight-bolder">
					Sin hijos {{ indexLivingTab == 0 ? "vivos" : "muertos" }}
				</div>
			</b-tabs>
		</div>
	</b-sidebar>
</template>

<script>
import specimensService from "@/services/specimens.service"
import CombChickenlegsCintillos from "@/views/amg/encaste/lotes/components/CombChickenlegsCintillos.vue"
import ShowChicksGlobalByEvo from "./ShowChicksGlobalByEvo.vue"
export default {
	name: "SidebarChicksGlobal",
	components: {
		CombChickenlegsCintillos,
		ShowChicksGlobalByEvo,
	},
	props: {
		specimen: {
			type: Object,
			required: true,
		},
		yearSelected: {
			type: String | Number,
		},
	},
	async mounted() {
		this.isPreloading()
		await this.getSons()
		this.visibleChanges = true
		this.isPreloading(false)
	},
	computed: {
		title() {
			let { alias, plate } = this.specimen
			return `Hijos global de ${alias ? alias : ""} (${plate})`
		},
	},
	watch: {
		indexTab(newValue, oldValue) {
			if (newValue !== oldValue) {
				this.refreshData()
			}
		},
		indexLivingTab(newValue, oldValue) {
			if (newValue !== oldValue) {
				this.buildCountersAndData()
			}
		},
	},
	data() {
		return {
			visibleChanges: false,
			yearsTab: [],
			sons: [],
			indexTab: 0,
			posturasPerYear: [],
			posturasCP: [],
			posturasCA: [],
			posturasSpec: [],
			counterSons: 0,
			indexLivingTab: 0,
			livingCounter: 0,
			deadCounter: 0,
		}
	},
	methods: {
		async getSons() {
			const { status, all_sons } = await specimensService.getSonsGlobal(this.specimen.id)
			if (status && all_sons.length) {
				this.sons = all_sons
				this.counterSons = this.sons.map((it) => it.data).filter((it) => it.length != 0).length
				this.sons = this.sons.filter((it) => it.data.length != 0)
				this.setLivingCounter()
				this.setDeadCounter()
				this.buildCountersAndData()
			}
		},
		_calculateCounter(data, isLiving = true) {
			if (isLiving) {
				return data.eggs * 1 + data.chicks_all * 1 + data.specimens_all * 1
			}
			return data.dead_patas * 1 + data.dead_chicks_count * 1 + data.dead_specimens_count * 1
		},
		_processYearTabs(isLiving = true) {
			return this.sons
				.map((a) => ({
					year: a.year,
					counter: a.data.reduce((total, item) => {
						return total + this._calculateCounter(item, isLiving)
					}, 0),
				}))
				.filter((it) => it.counter != 0)
		},
		setLivingCounter() {
			const tabs = this._processYearTabs(true)
			this.livingCounter = tabs.reduce((a, b) => a + b.counter, 0)
		},
		setDeadCounter() {
			const tabs = this._processYearTabs(false)
			this.deadCounter = tabs.reduce((a, b) => a + b.counter, 0)
		},
		buildCountersAndData() {
			this.yearsTab = this._processYearTabs(this.indexLivingTab === 0)
			const index = this.yearsTab.findIndex((a) => a.year == this.yearSelected)
			this.indexTab = index == -1 ? 0 : index
			this.refreshData()
		},
		refreshData() {
			this.posturasPerYear = []
			this.posturasCP = []
			this.posturasCA = []
			this.posturasSpec = []
			if (this.indexTab < 0) return
			const selectedYear = this.yearsTab.length ? this.yearsTab[this.indexTab].year : null
			if (!selectedYear) return
			this.posturasPerYear = this.sons.find((s) => s.year === selectedYear)?.data
			const areDeads = this.indexLivingTab === 1
			if (this.sons.length == 0) return
			this.posturasCP =
				this.posturasPerYear.length > 0
					? this.posturasPerYear.filter((p) => p[areDeads ? "dead_patas" : "eggs"] * 1 > 0)
					: []
			this.posturasCA =
				this.posturasPerYear.length > 0
					? this.posturasPerYear.filter((p) => p[areDeads ? "dead_chicks_count" : "chicks_all"] * 1 > 0)
					: []
			this.posturasSpec =
				this.posturasPerYear.length > 0
					? this.posturasPerYear.filter((p) => p[areDeads ? "dead_specimens_count" : "specimens_all"] * 1 > 0)
					: []
		},
		closeSidebar() {
			this.visibleChanges = false
			this.$emit("hidden")
		},
	},
}
</script>

<style lang="scss">
.c-chick {
	border-radius: 5px;
	background: var(--primary);
	color: #ffff;
	padding: 5px 10px;
}
</style>
